import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadPrivacyPolicy () {
    const api = getApiClient(this.$store)

    api.get('privacy_policies/latest')
      .then(result => {
        this.privacyPolicy = result.data['hydra:member'][0]
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const options = {}

    api.post('privacy_policies', { content: this.privacyPolicy.content }, options)
      .then(() => {
        this.$store.commit('app/raiseSuccess', 'Política de privacidade atualizada')
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao atualizar Política de privacidade')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
